// extracted by mini-css-extract-plugin
export default {"notAvailable":"notAvaiblable_notAvailable__tsBSs","tooltip":"notAvaiblable_tooltip__f2aC0"};